<script lang="ts">
    import { TextInput } from "carbon-components-svelte";
    import { Button as CarbonButton, ButtonSet } from "carbon-components-svelte";
    import TrashCan32 from "carbon-icons-svelte/lib/TrashCan32";
    import Save32 from "carbon-icons-svelte/lib/Save32";

    import type {NamedRights} from './jmdb'
    import { deep_copy, newId, right_list, streamer_list, streamer_groups } from './jmdb';

    import RightsEditor from './RightsEditor.svelte';
    import stringify from 'fast-json-stable-stringify'

    export let namedRights : NamedRights
    let in_flight = false
    
    let oldRights = deep_copy(namedRights)
    let dirty = false
    let rightsEditor: RightsEditor

    $: dirty = stringify(oldRights) != stringify(namedRights)


    
    let refetchRelevant = function(): Promise<any> {
        return Promise.all([
            streamer_list.fetch(),
            streamer_groups.fetch(),
            right_list.fetch()])
    }

    let after_changes = (res: Response) => {
        if (!res.ok) {
            res.text().then((txt) => {
                window.alert(txt)
            })
            in_flight = false
        } else {
            right_list.invalidate()
            Promise.all([right_list.fetch()]).then(()=>{
                in_flight = false
            })
        }
    }
    let saveClicked = () => {
        let old = oldRights
        let changeBundle: any = {}
        const matchedFields = ["name"]
        matchedFields.forEach(el => {
            if ((old as any)[el] != (namedRights as any)[el]) {
                changeBundle[el] = (namedRights as any)[el]
            }
        })
        rightsEditor.addModifications(changeBundle, old)

        fetch("/api/v1/rights/"+namedRights.id, {
            'method': 'POST',
            'body': JSON.stringify(changeBundle)
        }).then(after_changes)
        in_flight = true
    }

    let deleteClicked = (e: Event) => {
        e.preventDefault();
        if (window.confirm("Are you sure you want to delete "+namedRights.name+"?")) {
            fetch("/api/v1/rights/"+namedRights.id, {
                'method': 'DELETE',
                'body': JSON.stringify({})
            }).then(after_changes)
        }
    }

    refetchRelevant()


</script>

<TextInput bind:value={namedRights.name} labelText="Name" placeholder="Enter permission set's display name"/>
    

<RightsEditor bind:this={rightsEditor} bind:rights={namedRights}/>


<ButtonSet stacked style="float: right;">
    <CarbonButton kind="primary" icon={Save32} disabled={!dirty || in_flight} on:click={saveClicked}>Save</CarbonButton>
    {#if namedRights.id != newId}
    <CarbonButton kind="danger-ghost" icon={TrashCan32} tooltipPosition="left" on:click={deleteClicked}>Delete</CarbonButton>
    {/if}
</ButtonSet>
